import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http"; // Import 
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
//import { MatListModule } from '@angular/material/list';
import {MsalConfModule} from './core/auth.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './feature/home/home.component';
import { HeaderComponent } from './shared/header/header.component';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AlertModule } from './_alert';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';

import { MsalRedirectComponent, MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { TextAnalysisComponent } from './feature/text-analysis/text-analysis.component';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatTableExporterModule } from 'mat-table-exporter';
import { MatSelectModule } from '@angular/material/select';
import { JobProfileMatchingComponent } from './feature/job-profile-matching/job-profile-matching.component';
import { TextSummarizerComponent } from './feature/text-summarizer/text-summarizer.component';
import { CommonModule } from '@angular/common';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';

import { JobProfileLandingComponent } from './feature/job-profile-landing/job-profile-landing.component';


@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        HeaderComponent,
        TextAnalysisComponent,
        JobProfileMatchingComponent,
        TextSummarizerComponent,
        JobProfileLandingComponent
    ],
    bootstrap: [AppComponent, MsalRedirectComponent], imports: [
        // NgbModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        MatButtonModule,
        MatToolbarModule,
        MatProgressBarModule,
        MatInputModule,
        MatTableModule,
        MatTabsModule,
        MatPaginatorModule,
        MatSelectModule,
        MatSortModule,
        MatCardModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatTableExporterModule,
        MsalConfModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        AlertModule,
        NgxSliderModule,
        FormsModule,
        DragDropModule,
        MatIconModule,
        ReactiveFormsModule,
        CommonModule,
        AutocompleteLibModule], providers: [
        AppComponent,
        HeaderComponent,
        JobProfileLandingComponent,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        MsalGuard,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }